module.exports = function divergence(a, b) {
    var i = 0,
        ii = a.length,
        d = 0;
    for (; i < ii; i++) {
        d += ((a[i] - b[i]) * (a[i] - b[i])) / ((a[i] + b[i]) * (a[i] + b[i]));
    }
    return 2 * d;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-distance/src/distances/divergence.js
 ** module id = 62
 ** module chunks = 0
 **/